// Fetch recently viewed products
var recently_viewed_products =
  JSON.parse(localStorage.getItem("recently_viewed_products")) || [];
let PPATH = window.location.pathname;
let title = "";
jQuery.getJSON(PPATH + ".js", function (product) {
  var current_product = {
    title: product.title,
    url: location.href,
    img:product.featured_image,
    price:(product.price/100),
    available:product.available,
    PID:product.variants[0].id,
    created_at:product.created_at,
  };

  // Remove duplicates
  recently_viewed_products = recently_viewed_products.filter(function (
    product
  ) {
    return product.url !== current_product.url;
  });

  // Add the current product to the beginning of the list
  recently_viewed_products.unshift(current_product);

  // Limit the list to a certain number of products (e.g., 25)
  if (recently_viewed_products.length > 25) {
    recently_viewed_products.pop();
  }

  // Update the list in localStorage
  localStorage.setItem(
    "recently_viewed_products",
    JSON.stringify(recently_viewed_products)
  );
});

// Add the currently viewed product to the list
